// extracted by mini-css-extract-plugin
export default {"back":"BackButton_back__9Sjyn","chevronIcon":"BackButton_chevronIcon__7EwM1"};